module.exports = __webpack_public_path__ + "static/media/n18.09a3c0f6.JPG";